import { Button } from '@mui/material';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { useAuthStore } from 'services/hooks';
import { locations } from 'services/routes/locations';

const CustomLink = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
  <Link ref={ref} {...props} />
));

CustomLink.displayName = 'CustomLink';

const StartFreeButton = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { authStore } = useAuthStore();
  const { isLoggedIn } = authStore;

  return (
    <>
      {!isLoggedIn && (
        <Button
          variant="rounded"
          component={CustomLink}
          state={{ from: location }}
          to={locations.general.register.pathname('')}
          data-testid="start-now-button"
        >
          {t('general:topBar:startNow').toUpperCase()}
        </Button>
      )}
    </>
  );
};

export default StartFreeButton;
